/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_7907ca76{border:0;outline:0;width:100%}.editingInput_7907ca76::-ms-clear{display:none}.editingContainer_7907ca76{margin:4px}"}]);
export const editingInput = "editingInput_7907ca76";
export const editingContainer = "editingContainer_7907ca76";